"use client";

import { useEffect, useState } from "react";
import Image from "next/image";

export default function FloatingContactIcons() {
  // The footer's social icons live in the same bottom-right corner as this
  // fixed widget, so once that row scrolls into view the widget would sit
  // on top of them — fade it out while the footer's bottom bar is visible.
  const [nearFooter, setNearFooter] = useState(false);

  useEffect(() => {
    const target = document.getElementById("footer-bottom-bar");
    if (!target) return;

    const observer = new IntersectionObserver(
      ([entry]) => setNearFooter(entry.isIntersecting),
      { rootMargin: "0px 0px -10% 0px" }
    );
    observer.observe(target);
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <style jsx global>{`
        @keyframes zoomPulse {
          0% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.15);
          }
          100% {
            transform: scale(1);
          }
        }
        .zoom {
          animation: zoomPulse 2s infinite ease-in-out;
        }
      `}</style>

      <div
        className={`fixed bottom-6 right-6 z-[9999] flex items-center gap-3 transition-opacity duration-300 ${
          nearFooter ? "pointer-events-none opacity-0" : "opacity-100"
        }`}
      >
        <a
          href="https://wa.me/971589361909?text=Hello%2C%20I%20need%20assistance%20with%20gold%20investment"
          target="_blank"
          rel="noopener noreferrer"
          className="hidden items-center gap-2 rounded-full bg-white px-4 py-2.5 shadow-lg sm:flex"
        >
          <span className="flex flex-col items-start leading-tight">
            <span className="text-sm font-semibold text-primary-900">
              Gold Support
            </span>
            <span className="flex items-center gap-1.5 text-xs text-text-muted">
              <span className="h-1.5 w-1.5 rounded-full bg-success" />
              Online
            </span>
          </span>
        </a>
        <a
          href="https://wa.me/971589361909?text=Hello%2C%20I%20need%20assistance%20with%20gold%20investment"
          target="_blank"
          rel="noopener noreferrer"
          className="zoom block"
        >
          <Image
            src="/whatsapp-color.svg"
            alt="WhatsApp"
            width={60}
            height={60}
            className="w-16 h-16 bg-white rounded-full shadow-lg p-2"
          />
        </a>
      </div>
    </>
  );
}
